import React from "react";
import DateToday from "./DateToday";

export default function TopTitleBannerMobile(props) {
  return (
    <div className="main-top-title-banner-container">
      <div className="date-container-mobile">
        <DateToday />
      </div>
      <div className="title-text-banner-mobile">{props.title}</div>
    </div>
  );
}
